import React from 'react';
import Newsletter from '../NewsLetter/Newletter';
import Footer from '../Footer/Footer';
import Copyright from '../Copyrights/Copyright';
function Combainbottom() {
    return (
    
        <div className='combainbottom'>
            <Newsletter />
            <Footer />
            <Copyright />
        </div>
        
        
    );
}

export default Combainbottom;